import { message } from "antd";
import endpoints from "../utils/endpoints";
import { removeEmpty } from "../utils/objectUtils";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";

export async function getRolesList(params?: any){
    let res = {
      count: 0,
      page: null,
      perpage: 0,
      list: [],
    };
    
    if(params) {
      params = removeEmpty(params)
    }
    
    await Api.get(endpoints.getRolesList, {params}).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get data from servers')
    })
    
    return res
}

export async function deleteRoleById(params: any){
    await Api.get(endpoints.deleteRoleById, {params}).then((response) => {
      if(response.status === 200) {
          if(response.data.error) {
              notificationError(`${response.data.message}`)
          } else {
              notificationSucces('Role deleted successfully')
          }
      }
    }).catch((err: string) => {
      notificationError('Could not delete the role')
    })
}

export async function getRoleDetails(params: any){
    let res = {
        count: 0,
        page: null,
        perpage: 0,
        list: [],
      };
      await Api.get(endpoints.getRoleDetails, {params}).then((response) => {
        res = response.data
      }).catch((err: string) => {
        notificationError('Could not get data from servers')
      })
      
      return res
}

export async function createOrUpdateRole(payload: any) {
  await Api.post(endpoints.createRole, payload).then((response) => {
    if(response.status === 200) {
        if(response.data.error) {
          notificationError(`${response.data.message}`)
        } else {
          if(!payload.id) notificationSucces('Role was successfully created')
          if(payload.id) notificationSucces('Role was successfully updated')
        }
    } else {
      notificationError(`${response.status}`)
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })
}

export async function getRoleById (params: any) {
  let res = {
    externalId: '',
    roleName: '',
    affiliation: '',
    permissions: [],
  };
  await Api.get(endpoints.getRoleById, {params}).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })
  
  return res
}